import { collection, doc, getDocs, writeBatch, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";

// Every subcollection under users/{uid}. "Delete all my data" and "Delete account" empty each one.
// A test checks this list against firestore.rules, so a new collection can't be forgotten here.
export const USER_COLLECTIONS = ["tasks", "goals", "visions", "dreams", "fears", "keyDates", "days", "nudges", "data"];

// Firestore batches hold at most 500 writes, so each collection is deleted in pages.
const deleteCollection = async (uid, name) => {
  const ref = collection(db, "users", uid, name);
  for (;;) {
    const snap = await getDocs(ref);
    if (snap.empty) return;
    const batch = writeBatch(db);
    snap.docs.slice(0, 499).forEach(d => batch.delete(d.ref));
    await batch.commit();
  }
};

export async function deleteUserData(uid) {
  await Promise.all(USER_COLLECTIONS.map(name => deleteCollection(uid, name)));
  await deleteDoc(doc(db, "users", uid));
}
